<div class="documento_item">
  <div [ngClass]="{'documento-parent': !hideBorder}">
    <div class="d-flex" *ngIf="!hideHeader">
      <div class="p-2" style="font-weight: 800;">{{model.tipologia}}</div>
      <div class="ml-auto p-2" *ngIf="!hideHeaderButtons">
        <button style="padding: 0;" type="button" pButton pRipple icon="pi pi-pencil" class="p-button-text"
          (click)="editEmitter($event)"></button>
        <button style="padding: 0;" type="button" pButton pRipple icon="pi pi-trash" class="p-button-text"
          (click)="deleteEmitter($event)"></button>
      </div>
    </div>
    <div *ngIf="model.path">
      <div class="mt-1">
        Documento caricato il {{model.lastModified| date:"dd/MM/yyyy"}}
        <div>
          <a [href]="'/static/' + model.path" target=”_blank”>{{model.nome}}</a>
          <button style="padding: 0;" type="button" pButton pRipple icon="pi pi-trash" class="p-button-text"
            (click)="onDelete($event)" *ngIf="!hideDeleteButton"></button>
        </div>
      </div>
    </div>
    <div *ngIf="!model.path">
      <div style="text-align: center;">
        <app-documentopicker [accept]="'.csv,.pdf,.zip,.xls,.xlsx,.doc,.docx,.rar,.txt,.png,.jpg,.jpeg,.tiff'"
          [ngClass]="model.obbligatorio ? 'mandatory' : 'not_mandatory'" [(model)]="model" [label]="model.tipologia">
        </app-documentopicker>
      </div>
    </div>
  </div>
</div>